



// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';

// const HomeSports = (props) => {
//     const homeData = props.data || []
//     console.log("HomeSports----", homeData)
//     const [data, setData] = useState({});
//     const [loading, setLoading] = useState(true);

//     // Define default static data matching the backend structure and HomeSports layout
//     const defaultData = {
//         main_news: {
//             featured: {
//                 title: "खेल की ताज़ा खबरें",
//                 category: "रैपुरा में कैट के राष्ट्रीय अध्यक्ष का आगमन आज, जिलाध्यक्ष केसरवानी ने लोगो से समय पर पहुंचने एवं स्वागत करने हेतु की अपील",
//                 date: "2025-10-06",
//                 image: "/assets/img/news/news31.jpg"
//             },
//             list: [
//                 {
//                     title: "ब्रह्माकुमारी अवधेश दीदी को भावपूर्ण श्रद्धांजलि अर्पित",
//                     image: "/assets/img/news/news32.jpg",
//                     category: "News",
//                     date: "2017-01-17",
//                     description: "" // No description in original, so empty
//                 },
//                 {
//                     title: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
//                     image: "/assets/img/news/news33.jpg",
//                     category: "News",
//                     date: "2017-02-10",
//                     description: ""
//                 },
//                 {
//                     title: "पन्ना टाइगर रिजर्व में तेंदुए की हुई संदिग्ध मौत , शरीर पर कई जगह थे घाव",
//                     image: "/assets/img/news/news34.jpg",
//                     category: "News",
//                     date: "2017-03-06",
//                     description: ""
//                 },
//                 {
//                     title: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
//                     image: "/assets/img/news/news35.jpg",
//                     category: "News",
//                     date: "2017-05-17",
//                     description: ""
//                 },
//                 {
//                     title: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
//                     image: "/assets/img/news/news36.jpg",
//                     category: "News",
//                     date: "2017-08-22",
//                     description: ""
//                 },
//                 {
//                     title: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार.",
//                     image: "/assets/img/news/news37.jpg",
//                     category: "News",
//                     date: "2017-12-30",
//                     description: ""
//                 }
//             ]
//         },
//         sidebar: {
//             social_links: [
//                 { platform: "facebook", icon: "fa fa-facebook", follows: "50k" },
//                 { platform: "instagram", icon: "fa fa-instagram", follows: "10k" },
//                 { platform: "youtube", icon: "fa fa-youtube", follows: "25k" },
//                 { platform: "twitter", icon: "fa fa-twitter", follows: "20k" }
//             ],
//             weather: {
//                 location: "Panna, IN",
//                 time: "6:03 pm, Oct 7, 2025",
//                 temperature: "42",
//                 condition: "hello",
//                 image: "/assets/img/rain-6243559_1280.jpg"
//             },
//             recent_news: [
//                 { title: "Rosie Hutin ghton Habits Career.", image: "/assets/img/news/news283.jpg" },
//                 { title: "Someone Has Cal The Total Cost", image: "/assets/img/news/news284.jpg" },
//                 { title: "Rosie Hutin ghton Habits Career.", image: "/assets/img/news/news285.jpg" },
//                 { title: "Rosie Hutin ghton Habits Career.", image: "/assets/img/news/news282.jpg" },
//                 { title: "Rosie Hutin Ghton Habits Career.", image: "/assets/img/news/news286.jpg" },
//                 { title: "Rosie Hutin Ghton Habits Career.", image: "/assets/img/news/news287.jpg" }
//             ]
//         }
//     };

//     useEffect(() => {
//         let mounted = true;
//         const fetchData = async () => {
//             try {
//                 console.log("Fetching sports data...");
//                 const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/v1/users/sports/all`);
//                 console.log("Res :homesports : ",res,res.data)
//                 if (!mounted) return;
//                 const fetchedData = res.data.data[0] || defaultData;
//                 console.log("Fetched sports data:", fetchedData);
//                 setData(fetchedData);
//             } catch (err) {
//                 console.error("Error fetching sports:", err);
//                 setData(defaultData);
//             } finally {
//                 if (mounted) setLoading(false);
//             }
//         };
//         fetchData();
//         return () => {
//             mounted = false;
//         };
//     }, []);

//     // If props.data is provided, map it to the expected structure
//     const mapPropsDataToStructure = (propsData) => {
//         if (!propsData || propsData.length === 0) return defaultData;

//         const section = propsData[0];
//         const mainSportsNews = section.mainSportsNews || {};
//         const subNews = section.subNews || [];

//         // Map mainSportsNews to main_news.featured
//         const featured = {
//             title: section.sectionTitle || "खेल की ताज़ा खबरें",
//             category: mainSportsNews.category || "News",
//             date: mainSportsNews.date || "2025-10-06",
//             image: mainSportsNews.imageUrl || "/assets/img/news/news31.jpg"
//         };

//         // Map subNews to main_news.list
//         const list = subNews.map(item => ({
//             title: item.title?.[0] || "No Title",
//             image: item.imageUrl?.[0] || "/assets/img/news/news32.jpg",
//             category: item.category?.[0] || "News",
//             date: item.date?.[0] || "2017-01-17",
//             description: "" // No description in provided data, so empty
//         }));

//         return {
//             main_news: {
//                 featured,
//                 list
//             },
//             sidebar: defaultData.sidebar // Keep sidebar static as it's not in props data
//         };
//     };

//     // Use props data if available, otherwise use fetched or default
//     const finalData = homeData.length > 0 ? mapPropsDataToStructure(homeData) : data;

//     if (loading && homeData.length === 0) {
//         return <div>Loading...</div>;
//     }

//     return (
//         <>
//             <section className="bg-body section-space-less30">
//                 <div className="container">
//                     <div className="ne-isotope">
//                         <div className="row">
//                             <div className="col-12">
//                                 <div className="topic-border color-azure-radiance mb-30">
//                                     <div className="topic-box-lg color-azure-radiance">{finalData.main_news?.featured?.title}</div>
//                                 </div>
//                             </div>
//                         </div>
//                         <div className="featuredContainer">
//                             <div className="row tenies">
//                                 <div className="col-xl-4 col-lg-7 col-md-6 col-sm-12">
//                                     <div className="img-overlay-70 img-scale-animate mb-30">
//                                         <img 
//                                             src={finalData.main_news?.featured?.image} 
//                                             alt="news" 
//                                             className="img-fluid width-100" 
//                                             style={{ height: '400px', objectFit: 'cover' }} // Fixed height and object-fit for uniform size
//                                         />
//                                         <div className="topic-box-top-lg">
//                                             <div className="topic-box-sm color-cod-gray mb-20">{finalData.main_news?.featured?.category}</div>
//                                         </div>
//                                         <div className="mask-content-lg">
//                                             <div className="post-date-light">
//                                                 <ul>
//                                                     <li>
//                                                         <span>
//                                                             <i className="fa fa-calendar" aria-hidden="true" />
//                                                         </span>{new Date(finalData.main_news?.featured?.date).toLocaleDateString()}
//                                                     </li>
//                                                 </ul>
//                                             </div>
//                                             <h2 className="title-medium-light size-lg">
//                                                 <Link to="/news_info">{finalData.main_news?.featured?.category}</Link>
//                                             </h2>
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="col-xl-8 col-lg-5 col-md-6 col-sm-12">
//                                     <div className="row keep-items-4-md">
//                                         {finalData.main_news?.list?.map((item, index) => (
//                                             <div key={index} className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
//                                                 <div className="mb-25 position-relative">
//                                                     <Link className="img-opacity-hover" to="/news_info">
//                                                         <img 
//                                                             src={item.image} 
//                                                             alt="news" 
//                                                             className="img-fluid width-100 mb-15" 
//                                                             style={{ height: '200px', objectFit: 'cover' }} // Fixed height and object-fit for uniform size
//                                                         />
//                                                     </Link>
//                                                     <div className="topic-box-top-xs">
//                                                         <div className="topic-box-sm color-cod-gray mb-20">{item.category}</div>
//                                                     </div>
//                                                     <div className="post-date-dark">
//                                                         <ul>
//                                                             <li>
//                                                                 <span>
//                                                                     <i className="fa fa-calendar" aria-hidden="true" />
//                                                                 </span>{new Date(item.date).toLocaleDateString()}
//                                                             </li>
//                                                         </ul>
//                                                     </div>
//                                                     <h3 className="title-medium-dark size-md">
//                                                         <Link to="/news_info">{item.title}</Link>
//                                                     </h3>
//                                                 </div>
//                                             </div>
//                                         ))}
//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </section>
//         </>
//     );
// };

// export default HomeSports;












import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import './HomeSports.css'; // Ensure this CSS file has the styles for the grid and featured image

const HomeSports = () => {
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);

    // Define default static data matching the backend structure (assuming similar to Country/Politics)
    const defaultData = {
        main_news: {
            featured: {
                title: "खेल की ताज़ा खबरें",
                category: "यमुनोत्री जाते समय चलती कार में गिरा पहाड़: 3 लोग सवार, बिहार से आए दर्शन करने; रेस्क्यू ऑपरेशन जारी – Uttarkashi News",
                date: "2017-03-22T17:49",
                // image: "/assets/img/ezgif-5530dd1da8b37c_1759988348.webp"
                image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766689123/ezgif-5530dd1da8b37c_1759988348_zs5bii.webp"
            },
            list: [
                {
                    title: "जहरीला कफ सिरप बनाने वाली कंपनी का डायरेक्टर गिरफ्तार:– Madhya Pradesh",
                    // image: "/assets/img/live-update-centre-2025-10-09t081936484_1759978108.webp",
                    image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688154/live-update-centre-2025-10-09t081936484_1759978108_amjvky.webp",
                    category: "News",
                    date: "2017-03-22T17:50",
                    description: "मध्य प्रदेश में 23 बच्चों की मौत का कारण बने कोल्ड्रिफ कफ सिरप बनाने वाली कंपनी श्रीसन फार्मा का डायरेक्टर गोविंदन रंगनाथन गिरफ्तार कर लिया गया है। मामले में मध्य प्रदेश सरकार द्वारा बनाई गई SIT की टीम ने बुधवार-गुरुवार की दरमियानी रात तमिलनाडु के...."
                },
                {
                    title: "हरियाणा IPS सुसाइड केस; 2 धड़ों में बंटे अफसर:– Chandigarh News",
                    // image: "/assets/img/ezgif-25eec5267e400a_1759978236.webp",
                    image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/ezgif-25eec5267e400a_1759978236_l0w35c.webp",
                    category: "News",
                    date: "2017-03-22T02:34",
                    description: "हरियाणा के IPS अफसर IG वाई पूरन कुमार का सुसाइड केस अब तूल पकड़ता दिख रहा है। इस मामले में IPS-IAS अफसरों के साथ ही HCS और HPS अफसर भी दो धड़ों में बंटे हैं। एससी वर्ग के अफसर वाई पूरन कुमार को न्याय दिलाने के लिए लामबंद हो रहे हैं।....."
                },
                {
                    title: "नागपुर से मिला था छिंदवाड़ा को ‘मौत का अलर्ट:– Madhya Pradesh News",
                    // image: "/assets/img/11-1_1759952360.webp",
                    image: "https://res.cloudinary.com/dvmmjh9a2/image/upload/v1766688163/11-1_1759952360_dcagf4.webp",
                    category: "News",
                    date: "2017-03-22T02:34",
                    description: "छिंदवाड़ा में कोल्ड्रिफ कफ सिरप से हुई बच्चों की मौतों को टाला जा सकता था, यदि जिला प्रशासन नागपुर से मिले अलर्ट को सीरियसली लेता। दरअसल, नागपुर के कलर्स अस्पताल के संचालक डॉ. राजेश अग्रवाल ने 15 सितंबर को ही परासिया के स्थानीय पार्षद अनुज पाटकर को....."
                }
            ]
        },

    };

    useEffect(() => {
        let mounted = true;
        const fetchData = async () => {
            try {
                console.log("Fetching sports data...");
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}api/v1/users/sports/all`);
                console.log("res : sports :", res, res.data)
                if (!mounted) return;
                const fetchedData = res.data.data[0] || defaultData;
                console.log("Fetched sports data:", fetchedData);
                setData(fetchedData);
            } catch (err) {
                console.error("Error fetching sports:", err);
                setData(defaultData);
            } finally {
                if (mounted) setLoading(false);
            }
        };
        fetchData();
        return () => {
            mounted = false;
        };
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    const featured = data.main_news?.featured;
    const list = data.main_news?.list || [];

    return (
        <section className="section-space-bottom-less30 mt-lg-5">
            <div className="container">
                <div className="topic-border color-cod-gray mb-30">
                    <div className="topic-box-lg color-cod-gray">{data.main_news?.featured?.title}</div>
                </div>
                {/* ------------ FEATURED TOP NEWS ----------- */}
                <div className="featured-news-card mb-5">
                    <img
                        src={
                            Array.isArray(featured?.image)
                                ? featured.image[0]
                                : featured?.image
                        }
                        alt="featured"
                        className="featured-image"
                        onError={(e) => {
                            console.log("Featured image failed to load:", e.target.src);
                            e.target.src = "/assets/img/placeholder.jpg";
                        }}
                    />

                    <div className="featured-overlay">
                        <span className="cat-badge">{featured?.title}</span>
                        <h1 className="featured-title">
                            <Link to="/news_info">{featured?.category}</Link>
                        </h1>

                        <p className="featured-date" style={{ fontSize: "20px" }}>
                            <i className="fa fa-calendar"></i>{" "}
                            {new Date(featured?.date).toLocaleDateString()}
                        </p>
                        <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "" }} />
                        <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "", margin: "10px" }} />
                        <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "", margin: "10px" }} />
                    </div>
                </div>

                {/* ------------ NEWS GRID LIST ----------- */}
                <div className="row" style={{marginTop:"40px"}}>
                    {list.map((item, index) => (
                        <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                            <div className="news-card">
                                <Link to="/news_info">
                                    <img
                                        src={
                                            Array.isArray(item.image)
                                                ? item.image[0]
                                                : item.image
                                        }
                                        alt="news"
                                        className="news-img"
                                        onError={(e) => {
                                            console.log("Grid image failed to load:", e.target.src);
                                            e.target.src = "/assets/img/placeholder.jpg";
                                        }}
                                    />
                                </Link>

                                <div className="news-content">
                                    <span className="news-cat">{item.category}</span>

                                    <h3 className="news-title">
                                        <Link to="/news_info">{item.title}</Link>
                                    </h3>

                                    <p className="news-desc">{item.description}</p>

                                    <p className="news-date" style={{ fontSize: "18px", color: "black", fontFamily:"sans-serif" }}>
                                        <i className="fa fa-calendar"></i>{" "}
                                        {new Date(item.date).toLocaleDateString()}
                                        <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                                        <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                                        <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeSports;

